// Stumble Home — stub module. The game is in design; see DESIGN.md.
// This module satisfies the game module interface so the game appears in the lobby.

export interface StumbleHomeConfig {
  _placeholder?: never;
}

export const DEFAULT_CONFIG: StumbleHomeConfig = {};

export interface StumbleHomeState {
  phase: 'design';
  players: { id: string; name: string }[];
}

// No actions yet — game logic is not implemented.
export type StumbleHomeAction = { type: '_noop' };

export function createGame(
  _config: StumbleHomeConfig,
  players: { id: string; name: string }[],
  _seed = Date.now(),
): StumbleHomeState {
  return { phase: 'design', players };
}

export function applyAction(state: StumbleHomeState, _action: StumbleHomeAction): StumbleHomeState {
  return state;
}

export function getPlayerView(state: StumbleHomeState, _playerId: string | null): StumbleHomeState {
  return state;
}

export function describe(_config: StumbleHomeConfig): string {
  return 'Stumble Home — silent cooperative 3-player trick-taker on a triangular grid. Game in design.';
}

export function getBotAction(_player: { id: string }, _state: StumbleHomeState): StumbleHomeAction {
  return { type: '_noop' };
}

export function getValidActions(_state: StumbleHomeState, _playerId: string): string[] {
  return [];
}
